/** Filter types.
 * Enumeration of available awareness event filters.
 */
export enum AwarenessEventFilterType {
  AlarmType = 'AlarmType',
  UnitType = 'UnitType',
  UnitName = 'UnitUuid',
  DetectedZone = 'DetectedZone',
  AlarmStatus = 'Value'
}